<div class="align-self-center d-flex justify-content-center">
    <div class="progress-loader" [hidden]="!loading">
        <mat-progress-spinner class="spinnerContainer" strokeWidth="3" [diameter]="80" mode="indeterminate" color="accent">
        </mat-progress-spinner>
        <img src="assets/img/logo-hartmann.svg">
    </div>
  </div>